/* eslint-disable no-eval */
import { useEffect, useState } from 'react';
import { Args } from '../Components/Function';

const PATTERN = /##([^#:]+):?([^#]*)##/g;

export function useEvaluated(template: string, args: Args) {
	const [code, setCode] = useState<string>('');
	const [output, setOutput] = useState<() => string>(() => () => '');
	const [evalWithLocale, setEvalWithLocale] = useState<(value: string) => string>(() => () => '');
	const [error, setError] = useState<string | null>(null);

	useEffect(() => {
		const toEvalWithLanguage = (language: string) => {
			let input = 0;
			return template.replaceAll(PATTERN, (_, arg, argProp) => {
				if (arg === 'locale') {
					return JSON.stringify(language);
				}

				const format = (value: string | number) => {
					return argProp === 'raw' ? value : JSON.stringify(value);
				};

				if (arg === 'input') {
					const output = format(args.inputs[input].value);
					input++;

					return output;
				}

				if (args[arg]) {
					return argProp === 'raw'
						? args[arg]
						: JSON.stringify(arg === 'locale' ? language : args[arg]);
				}
			});
		};

		const newCode = toEvalWithLanguage(args.locale);

		try {
			eval(newCode);

			setOutput(() => () => eval(newCode));
			setCode(newCode);
			setEvalWithLocale(() => toEvalWithLanguage);
			setError(null);
		} catch (e) {
			setError(`${e.name}: ${e.message}`);
		}
	}, [template, args]);

	return [code, output, evalWithLocale, error] as const;
}
